export default __webpack_public_path__ + "static/media/spdb-image.303994d3.png";